import AddCardIcon from '@mui/icons-material/AddCard';
import React from 'react';
import Button from '@shared/components/Buttons/Button';

interface IntelligenceRequestEmptyStateProps {
  handleCreateIntelligenceRequest: () => void;
  manageMode?: boolean;
  private?: boolean;
}

const IntelligenceRequestEmptyState = (
  props: IntelligenceRequestEmptyStateProps,
): React.ReactElement => {
  const { handleCreateIntelligenceRequest, manageMode } = props;

  return (
    <div className="intelligence-request-empty">
      <AddCardIcon className="intelligence-request-empty__icon" />
      <h2 className="intelligence-request-empty__title">
        No Intelligence Requests Yet
      </h2>
      {manageMode
        ? (
            <>
              <p className="intelligence-request-empty__message">
                You haven't created any intelligence requests. Get started and
                gather valuable insights tailored to your needs.
              </p>
              <Button
                size="large"
                startIcon={<AddCardIcon />}
                onClick={handleCreateIntelligenceRequest}
              >
                Create Intelligence Request
              </Button>
            </>
          )
        : (
            <p className="intelligence-request-empty__message">
              No Intelligence Requests available at the moment.
            </p>
          )}
    </div>
  );
};

export default IntelligenceRequestEmptyState;
